
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(366|43|685)|1(407|573|716|840)|(50|93)75|3597|4121|4909|6314|7398|8343|8959)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
